/* KAKIORA storefront enhancements. Single IIFE, no frameworks.
   Note: never attach a MutationObserver to a subtree this code writes into. */
(function () {
  'use strict';

  /* ---------- Sticky add-to-cart (mobile, product page) ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-kak-sticky-atc]');
    var form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    if (!bar || !form) return;

    var submit = form.querySelector('[name="add"]');
    var barBtn = bar.querySelector('[data-kak-sticky-add]');
    var barPrice = bar.querySelector('[data-kak-sticky-price]');

    function onScroll() {
      if (!submit) return;
      var rect = submit.getBoundingClientRect();
      var out = rect.bottom < 0 || rect.top > window.innerHeight;
      bar.classList.toggle('is-visible', out);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (barBtn) {
      barBtn.addEventListener('click', function () {
        if (submit && !submit.disabled) {
          submit.click();
        } else {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    /* keep sticky price in sync with selected variant.
       Dawn re-renders the price block asynchronously, so observe it
       (this code only READS the observed subtree, never writes into it). */
    function syncStickyPrice() {
      var priceEl = document.querySelector('.product__info-container .price__regular .price-item--regular, .product__info-container .price-item--sale');
      if (priceEl && barPrice) barPrice.textContent = priceEl.textContent.trim();
    }
    document.addEventListener('change', function (ev) {
      if (!ev.target.closest('variant-radios, variant-selects')) return;
      window.setTimeout(syncStickyPrice, 800);
      window.setTimeout(syncStickyPrice, 2000);
    });
    syncStickyPrice();
  }

  /* ---------- Bundle hint under variant pills (per-bar price/saving) ----------
     The hint node lives OUTSIDE the variant picker because Dawn replaces the
     picker's contents on every variant change. */
  function initVariantHints() {
    var dataEl = document.querySelector('[data-kak-bundle-data]');
    var picker = document.querySelector('variant-radios, variant-selects');
    if (!dataEl || !picker) return;

    var map;
    try { map = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var hint = document.createElement('p');
    hint.className = 'kak-variant-hint';
    hint.setAttribute('aria-live', 'polite');
    picker.insertAdjacentElement('afterend', hint);

    function update() {
      var current = document.querySelector('variant-radios, variant-selects');
      var checked = current ? current.querySelector('input[type="radio"]:checked') : null;
      var key = checked ? checked.value : null;
      hint.textContent = (key && map[key]) ? map[key] : '';
    }
    document.addEventListener('change', function (ev) {
      if (!ev.target.closest('variant-radios, variant-selects')) return;
      update();
      window.setTimeout(update, 700);
    });
    update();
  }

  /* ---------- FAQ: keep only one open per group (calmer for readers) ---------- */
  function initFaq() {
    document.querySelectorAll('[data-kak-faq]').forEach(function (group) {
      group.addEventListener('toggle', function (ev) {
        var d = ev.target;
        if (!(d instanceof HTMLDetailsElement) || !d.open) return;
        group.querySelectorAll('details[open]').forEach(function (other) {
          if (other !== d) other.open = false;
        });
      }, true);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- A11y: ensure quantity inputs are labelled ---------- */
  function labelQuantityInputs() {
    document.querySelectorAll('input.quantity__input:not([aria-label])').forEach(function (input) {
      input.setAttribute('aria-label', document.documentElement.lang.indexOf('nl') === 0 ? 'Aantal' : 'Quantity');
    });
  }

  ready(function () {
    initStickyAtc();
    initVariantHints();
    initFaq();
    labelQuantityInputs();
  });
})();
